import React, { Component, Fragment } from 'react';
import { connect } from "react-redux";
import * as Func from '../../../../helpers/functions';
import * as HMS from "../../common/component/Index";
import Input from '../../common/component/Input';
import { DATE_TIME_FORMAT } from '../../../../constants/Define';
import { siteCodes } from '../../../../models/VinWonder'
import { ticketTypes } from '../../../../models/VinWonderTicketItems'
import * as ANT from 'antd';
import moment from 'moment';

class VinWonderCheck extends Component {

    state = {
        serialNumber: undefined,
        isChecked: false,
    };

    onChange = (e) => {
        let params = Func.getValueForm(e);
        this.setState({
            serialNumber: typeof params.value === 'string' ? params.value.trimLeft() : params.value
        });
    };

    onCheckVinWonder = (e) => {
        e.preventDefault();
        this.props.onResetCheck();
        if(this.state.serialNumber.trim()) {
            this.setState({ isChecked: false });
            this.props.onCheckVinWonder(this.state.serialNumber);
        }
    };

    componentWillReceiveProps(nextProps) {
        if (nextProps && nextProps.vinWonders) {
            this.setState({
                isChecked: nextProps.vinWonders.isChecked,
            });
        }
        if (nextProps && nextProps.vinWonders.resultCheck) {
            if (Object.keys(nextProps.vinWonders.resultCheck).length > 0) {
                this.setState({ resultCheck: nextProps.vinWonders.resultCheck });
            } else {
                this.setState({ resultCheck: undefined });
            }
        } else {
            this.setState({ resultCheck: undefined });
        }
    }

    render() {
        const { t } = this.props;
        const { serialNumber, resultCheck, isChecked, message } = this.state;

        return (
            <Fragment>
                <HMS.HeaderListComponent
                    path={this.props.match.path}
                    groupPath={'checkVinWonder'}
                />
                <ANT.PageHeader
                    title={t('navigation.checkVinWonder')}
                >
                    <form onSubmit={this.onCheckVinWonder}>
                        <div className="w100-percent flex-center align-center jus">
                            <HMS.FormWrapperInputComponent className="w100-percent mr-2" >
                                <Input placeholder={t('item.checkVinWonder.checkCode')} type={`text`}
                                    className={`form-control`}
                                    name={`serialNumber`} onChange={this.onChange}
                                    value={Func.checkUndefine(serialNumber)}
                                />
                            </HMS.FormWrapperInputComponent>
                            <ANT.Button type="primary" loading={isChecked} disabled={isChecked}
                                onClick={this.onCheckVinWonder}>
                                {t('item.checkVinWonder.title')}
                            </ANT.Button>
                        </div>
                    </form>
                </ANT.PageHeader>
                <HMS.WrapperComponent>
                    <HMS.LoadingComponent spinning={isChecked}>
                        {
                            resultCheck ? (
                                <ANT.Card size="small" title={t('item.checkVinWonder.info')}
                                    style={{ width: '100%' }}
                                    headStyle={{
                                        backgroundColor: '#084F8C',
                                        color: 'white'
                                    }}
                                >
                                    <div className="row mt-3">
                                        <div className="col-md-6">
                                            <ANT.Card type="inner" title={t('item.checkVinWonder.infoVW')}>
                                                <p>
                                                    <b>{t('item.checkVinWonder.vinWonderName')}</b>: {resultCheck.vinWonderName && resultCheck.vinWonderName}
                                                </p>
                                                <p>
                                                    <b>{t('item.checkVinWonder.siteCode')}</b>: {resultCheck.siteCode && {...siteCodes.find(item => item.id === parseInt(resultCheck.siteCode))}.text}
                                                </p>
                                                <p>
                                                    <b>{t('item.checkVinWonder.vinWonderTicketName')}</b>: {resultCheck.vinWonderTicketName && resultCheck.vinWonderTicketName}
                                                </p>
                                                <p>
                                                    <b>{t('item.checkVinWonder.ticketType')}</b>: {resultCheck.ticketType && {...ticketTypes.find(item => item.value === resultCheck.ticketType)}.text}
                                                </p>
                                                <p>
                                                    <b>{t('item.checkVinWonder.usingDate')}</b>: {resultCheck.usingDate && `${moment(resultCheck.usingDate).format(DATE_TIME_FORMAT.SHORT_DATE)}`}
                                                </p>
                                                <p>
                                                    <b>{t('item.checkVinWonder.statusCode')}</b>: {resultCheck.statusCode && t(`item.checkVinWonder.enumStatus.${resultCheck.statusCode}`)}
                                                </p>
                                            </ANT.Card>
                                        </div>
                                        <div className="col-md-6">
                                            <ANT.Card type="inner" title={t('item.checkVinWonder.infoTicket')}>
                                                <p>
                                                    <b>{t('item.checkVinWonder.fullname')}</b>: {resultCheck.fullname && resultCheck.fullname}
                                                </p>
                                                <p>
                                                    <b>{t('item.checkVinWonder.email')}</b>: {resultCheck.email && resultCheck.email}
                                                </p>
                                                <p>
                                                    <b>{t('item.checkVinWonder.phoneNumber')}</b>: {resultCheck.phoneNumber && resultCheck.phoneNumber}
                                                </p>
                                            </ANT.Card>
                                        </div>
                                    </div>
                                </ANT.Card>
                            ) : (
                                    <ANT.Empty image={ANT.Empty.PRESENTED_IMAGE_SIMPLE}
                                        description={
                                            message ? <span
                                                className="colorRed">{message}</span> : t('item.checkVinWonder.checkCode')
                                        } />
                                )
                        }
                    </HMS.LoadingComponent>
                </HMS.WrapperComponent>
            </Fragment>
        );
    }
}

export default VinWonderCheck;
